import {DatePipe, LOCATION_INITIALIZED} from '@angular/common';
import {APP_INITIALIZER, enableProdMode, ErrorHandler, Injector, NgModule} from '@angular/core';
import {Http, HttpModule} from '@angular/http';
import {BrowserModule} from '@angular/platform-browser';
import {IonicApp, IonicErrorHandler, IonicModule} from 'ionic-angular';
import {DpDatePickerModule} from 'ng2-date-picker';
import {DetailPage} from '../pages/detail/detail';
import {MoreDetails} from '../pages/detail/more-details';
import {FavoriteExternPage} from '../pages/favorite-extern/favorite-extern';
import {FavoritePage} from '../pages/favorite/favorite';
import {FileResultListPage} from '../pages/file-result-list/file-result-list';
import {HomePage} from '../pages/home/home';
import {ImprintPage} from '../pages/imprint/imprint';
import {LastSearchQueryPage} from '../pages/last-search-query/last-search-query';
import {LoginPage} from '../pages/login/login';
import {ReferenceResultsPage} from '../pages/reference-results/reference-results';
import {ExtendedSearch} from '../pages/search/extended-search/extended-search';
import {SearchPage} from '../pages/search/search';
import {SearchresultsPage} from '../pages/searchresults/searchresults';
import {SettingsPage} from '../pages/settings/settings';
import {ConfigService} from '../providers/config';
import {SearchService} from '../providers/search';
import {UserService} from '../providers/user';
import {AppConfig} from '../shared/app.config';
import {ErrorHandling} from '../shared/error.handling';
import {FileSizePipe} from '../shared/filesize.pipe';
import {GroupByPipe} from '../shared/group-by.pipe';
import {SafeUrlPipe} from '../shared/safe-url.pipe';
import { SetIconClassPipe } from '../shared/set-icon-class.pipe';
import {SubStrPipe} from '../shared/substr.pipe';
import {TranslateCategoryPipe} from '../shared/translate-category.pipe';
import {TranslateCondidtionsPipe} from '../shared/translate-conditions.pipe';
import {MyApp} from './app.component';
import { IsMailPipe } from '../shared/email.pipe';
import { AppTheme } from '../apptheme/apptheme';

enableProdMode();

@NgModule({
    declarations: [
        MyApp,
        HomePage,
        SearchPage,
        SearchresultsPage,
        SettingsPage,
        FavoritePage,
        FavoriteExternPage,
        ImprintPage,
        DetailPage,
        ExtendedSearch,
        TranslateCondidtionsPipe,
        TranslateCategoryPipe,
        SetIconClassPipe,
        IsMailPipe,
        LoginPage,
        GroupByPipe,
        SubStrPipe,
        SafeUrlPipe,
        FileSizePipe,
        FileResultListPage,
        MoreDetails,
        ReferenceResultsPage,
        LastSearchQueryPage,
        AppTheme
    ],
    imports: [
        BrowserModule,
        HttpModule,
        DpDatePickerModule,
        IonicModule.forRoot(MyApp,
            {
                platforms: {
                    ios: {
                        scrollAssist: true,
                        autoFocusAssist: true
                    }
                }
            }
        )
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        MyApp,
        HomePage,
        SearchPage,
        SearchresultsPage,
        SettingsPage,
        FavoritePage,
        FavoriteExternPage,
        ImprintPage,
        DetailPage,
        ExtendedSearch,
        LoginPage,
        FileResultListPage,
        MoreDetails,
        ReferenceResultsPage,
        LastSearchQueryPage
    ],
    providers: [
        {provide: ErrorHandler, useClass: IonicErrorHandler},
        SearchService,
        UserService,
        AppConfig,
        ErrorHandling,
        DatePipe,
        AppTheme,
        ConfigService,
        {
            provide: APP_INITIALIZER,
            useFactory: factoryFunction,
            deps: [Http, ConfigService, Injector],
            multi: true
        }
    ]
})
export class AppModule {
}

/**
 * Calls the service to load the config.json once (async), afterwards it is cached and a synchronous access is possible
 * @param {Http} request
 * @param {ConfigService} config
 * @param {Injector} injector
 * @returns {() => Promise<any>}
 */
export function factoryFunction(request: Http, config: ConfigService, injector: Injector) {
    // Workaround as this is currently bugged in ie10+ https://github.com/angular/angular-cli/issues/5762
    return () => new Promise((resolve, reject) => {
        const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
        locationInitialized.then(() => {
            config.getConfigAsync().subscribe(() => {
                resolve();
            });
        });
    });
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts